import React, { useEffect, useRef, useState } from "react";
import { useNavigate ,useLocation } from "react-router-dom";
import { ReactComponent as LiveIcon } from "../../assets/Icons/live.svg";
import { ReactComponent as InfoIcon } from "../../assets/Icons/info.svg";
import { ReactComponent as Arrow } from "../../assets/Icons/filledArrow.svg";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ScheduleDetailsModal from "../../Components/Modals/ScheduleDetailsModal";
import LiveEpgContainer from "./LiveEpgContainer";
import { useDispatch, useSelector } from "react-redux";
import { getVideoSubscription } from "../Subscription/service"
import { fetchLiveChannels } from "./service";
import { getLiveScheduleData } from "../../Redux/LiveScheduleData/liveScheduleDataSlice";
import { convertUTCToLocal, getCurrentTime, getCurrentTimeAndDate, getDiffInMinutes, imageUrlCheck, onVideoPlayFunction, timeConversion } from "../../utils/utils";
import { getUserSubscription } from "../../network/service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import ContinueWithSubscriptionModal from "../../Components/Modals/ContinueWithSubscriptionModal";
import NoScheduleAvailableModal from "../../Components/Modals/NoScheduleAvailableModal";
import { ReactComponent as PauseButton } from "../../assets/Icons/pause2.svg";
import { ReactComponent as PlayButton } from "../../assets/Icons/play2.svg";
import parse from "html-react-parser";
import moment from "moment";
import Loading from "../../Components/Loading/Loading";
import { fetchFastChannels } from "./service";
import Select from 'react-select';
import Translate from "../../Components/Multilanguage/Translate";
let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;

const LiveChannels2 = ({ isHomepage, hideEpg, channelId }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const scheduleModal = useSelector((state) => state?.scheduleModal?.value);
  const liveScheduleData = useSelector((state) => state?.liveSchedule?.value);
  const selectedSchedule = useSelector((state) => state?.selectedSchedule?.value);
  const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
  const user = useSelector((state) => state?.user?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [sliceCount, setSliceCount] = useState(550);
  const [channelData, setChannelData] = useState();
  const [livePlayer, setLivePlayer] = useState();
  const [isReadMore, setIsReadMore] = useState(true);
  const [timeLeft, setTimeLeft] = useState()
  const [liveUrl, setLiveUrl] = useState("")
  const [loading, setLoading] = useState(true)
  const [isContinueWithSubscriptionModal, setIsContinueWithSubscriptionModal] = useState(false);
  const [fastchannelData,setFastChannelData] = useState();
  const [isNoScheduleAvailableModal , setIsNoScheduleAvailableModal] = useState(false);
  const [categories,setCategories] = useState();
  const [categoryButton, setCategoryButton] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCategoryName, setselectedCategoryName] = useState(categories?.[0]?.category_name || "Select Category");
  const [isCategoryChange ,setIsCategoryChange] = useState(false);
  const [isLiveVideoSub, setLiveVideoSub] = useState();
  const [videoSubscription,setVideoSubscription] = useState();
  const [subscribedUser , setSubscribedUser] = useState();
  const [channelPoster, setChannelPoster] = useState();
  const [isRadioLive, setIsRadioLive] = useState(false);
  const [isLivePlaying, setIsLivePlaying] = useState(false);
  const [isLivePaused, setIsLivePaused] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  
  const playerRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const pubid  = projectInfo?.projectConfig?.pubid;
  const queryParams = new URLSearchParams(location.search);
  const c = queryParams.get('c');

  // useEffect(() => {
  //   if(!selectedSchedule?.channel_id){
  //     if (liveScheduleData?.channels) {
  //       setChannelData(liveScheduleData?.channels[0]);
  //     }
  //   }
  // }, [liveScheduleData]);

  useEffect(() => {
    if (isHomepage && (!location.state || !location.state.homelive)) {
      navigate(location.pathname, { replace: true, state: { ...location.state, homelive: true } });
    }
    const isFromHomeLive = location.state?.homelive;
    if (isFromHomeLive) {
      location.state.homelive = null; 
    }
    if (pubid === 50057) {
      setLoading(false)
    }
  }, [location.state, channelData, channelId]);
  
  useEffect(() => {
    if (!isCategoryChange) {
      setChannelData(null);
      setFastChannelData(null);
      setLivePlayer(null);
      setLiveUrl(null);
    }
    if (liveScheduleData) {
      if (Object.entries(liveScheduleData).length > 0 && liveScheduleData.channels?.length > 0 && liveScheduleData?.schedules?.length > 0) {
        setLoading(false)
        setIsNoScheduleAvailableModal(false);
        if (!selectedSchedule?.channel_id) {
          const firstChannel = liveScheduleData.channels[0];
          const firstSchedule = liveScheduleData.schedules.find(sch => sch.channel_id === firstChannel.id);
          if (firstChannel && firstSchedule) {
            dispatch({
              type: "selectedSchedule/setSelectedSchedule",
              payload: { ...firstSchedule, channel_id: firstChannel.id }
            });
            setChannelData({ ...firstChannel, ...firstSchedule });
            setTimeout(() => {
              checkSubscription();
            }, 0);
          }
        } else {
          const filteredChannel = liveScheduleData?.channels?.filter((item) => selectedSchedule?.channel_id === item?.id)
         
          if (filteredChannel) {
            const channelInfo = filteredChannel[0]
            if (!isCategoryChange) {
              setChannelData({ ...channelInfo, ...selectedSchedule });
              setTimeout(() => {
                checkSubscription();
              }, 0);
            }
          }
        } 
      }
      else
      {
        if ( liveScheduleData.channels?.length === 0 && liveScheduleData.schedules?.length === 0 ) {
          setIsNoScheduleAvailableModal(true); 
        } else {
          setIsNoScheduleAvailableModal(false);
        }
      }
    }
    setIsCategoryChange(false);
    return () => localStorage.setItem("initialScheduleAdded", "false") //for showing first item from the schedule on nowplaying section
  }, [selectedSchedule, liveScheduleData]);

  useEffect(() => {
    if (channelData?.live_link) {

      checkSubscription()
      setTimeLeft(null)
      let diff = timeDifferenceHandler()
      if (diff > 60) {
        setTimeLeft(timeConversion(diff))
      } else if (diff > 0) {
        let leftTime = diff + "m"
        setTimeLeft(leftTime)
      }
    }
  }, [channelData,userSubscriptionData?.data])
  useEffect(() => {
    if (fastchannelData?.now_playing?.start_time) {
      const interval = setInterval(() => {
        let diff = timeDifferenceHandler()
        if (diff > 60) {
          setTimeLeft(timeConversion(diff))
        } else if (diff > 0) {
          let leftTime = diff + "m"
          setTimeLeft(leftTime)
        }
      }, 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [fastchannelData, timeLeft])

  const timeDifferenceHandler = () => {
    let time = getCurrentTimeAndDate()
    let currentTime = moment(time)
    let convertedEndTime = moment(fastchannelData?.now_playing?.end_time)
    let differenceInMinutes = convertedEndTime.diff(currentTime, "minutes")
    return differenceInMinutes
  }



  useEffect(() => {
    if (liveUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${liveUrl}`,
            type: "application/x-mpegURL",
          },
        ],
      };
      setLivePlayer(
        <VideoJS options={videoJsOptions} liveData={fastchannelData} onReady={handlePlayerReady}  is_live={true}  poster={channelPoster} isRadioLive={isRadioLive} />
      );
    }
  }, [liveUrl, hideEpg]);

  useEffect(() => {
    window.scroll(0, 0)
    fetchUserSubscriptionDetails();
    fetchLiveCategories();
  }, []);

    useEffect(() => {
      if (fastchannelData?.live_link) {
        if (
          (isLiveVideoSub?.length === 0) ||
          (subscribedUser)
        ) {
          setLiveUrl(fastchannelData.live_link);
          setIsLivePlaying(true);
          setIsLivePaused(false);
        }
      }
    }, [fastchannelData, isLiveVideoSub, subscribedUser]);

    const handleWatchNowLive = () => {
      if (fastchannelData?.live_link) {
        setLiveUrl(fastchannelData.live_link);
        setIsLivePlaying(true);
        setIsLivePaused(false);
      }
      const videoContainer = document.querySelector('.videoContainer');
      if (videoContainer) {
        videoContainer.scrollIntoView({ behavior: 'smooth' });
      }
    };

  const handlePauseLive = () => {
    setIsLivePaused(true);
    setIsLivePlaying(false);
  };

  const fetchLiveCategories = async () => {
    if (channelId) {
      setTimeout(() => {
        checkSubscription();
      }, 0);
      setPageLoading(false);
      return;
    }

    const fastChannelResponse = await  fetchLiveChannels(appInfo);

    if (fastChannelResponse.status === 200) {
  
       setCategories(fastChannelResponse?.data?.data?.categories);
      const cats = fastChannelResponse?.data?.data;
      if (cats && cats.length > 0 && !selectedCategory) {
        setSelectedCategory(cats[0]);
        setselectedCategoryName(cats[0]?.category_name);
        handleCategorySelection(cats[0]);
      }
      setPageLoading(false);
    }
   }
  const fetchUserSubscriptionDetails = async () => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {
      dispatch(
        getUserSubscriptionData({
          userSubscription: userSubResponse?.data,
        })
      );
    }
  };


  const checkSubscription = async () => {
    setIsContinueWithSubscriptionModal();

     let channelIdToUse;
    
    if (channelId) {
      channelIdToUse = channelId;
    } else if (c) {
      channelIdToUse = c;
    } else if (location?.state?.homelive === true && location?.state?.channelId) {
      channelIdToUse = location.state.channelId;
    } else if (channelData?.channel_id) {
      channelIdToUse = channelData.channel_id;
    } else {
      channelIdToUse = null;
    }

    if (!channelIdToUse) {
      setIsContinueWithSubscriptionModal(true);
      return;
    }
    const appInfo = {
      projectDetails: projectInfo,
      accessToken: accessToken,
    };

    const videoSubRespone = await getVideoSubscription(appInfo, channelIdToUse, 'channel');
      setVideoSubscription(videoSubRespone);
    const isSubscribedUser = matchSubscription(userSubscriptionData?.data, videoSubRespone?.data?.data)
       setSubscribedUser(isSubscribedUser );
    const fastChannelResponse = await fetchFastChannels(appInfo,channelIdToUse);
      setLiveVideoSub( fastChannelResponse?.data.data[0].subscriptions );
    let fastchannelInfo;
    if (fastChannelResponse?.status === 200) {
       fastchannelInfo = fastChannelResponse?.data?.data[0]
         if (fastchannelInfo ) {
              setFastChannelData({ ...fastchannelInfo });
              if (fastchannelInfo?.logo) {
                setChannelPoster(fastchannelInfo.logo_thumb);
              } else {
                setChannelPoster(projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE)
              }
            }    
    }
    if (videoSubRespone?.data?.data.length == 0) {
      setLiveUrl(fastchannelInfo?.live_link);
    } else {
      if (isSubscribedUser === true) {
        setLiveUrl(fastchannelInfo?.live_link);
      } else {
        setIsContinueWithSubscriptionModal(true);
      }
    }


  }

  const matchSubscription = (userSub, videoSub) => {
    const hasMatch = userSub.some((user) => videoSub.some((video) => user.sub_id === video.subscription_id));
    return hasMatch;
  };


  const handlePlayerReady = (player) => {
  playerRef.current = player;
  player.play().then(() => {
    setIsLivePlaying(true);
    setIsLivePaused(false);
  }).catch((error) => {
    console.warn("Autoplay failed:", error);
    setIsLivePlaying(false);
    setIsLivePaused(true);
  });

  player.on("play", () => {
    let event = videoStarted == true ? "POP09" : "POP02";
    videoStarted = true;
    updateLiveAnalytics(
      channelData,
      event,
       player.currentTime());
    setIsLivePlaying(true);
    setIsLivePaused(false); 
  });

  player.on("pause", () => {
    updateLiveAnalytics(
      channelData, 
      "POP04",
       player.currentTime());
    setIsLivePaused(true);
    setIsLivePlaying(false);
  });
  player.on("ended", () => {
    updateLiveAnalytics(channelData, "POP05", player.currentTime());
    setIsLivePlaying(false);
    setIsLivePaused(true);
  });

  player.on("dispose", () => {
    videoStarted = false;
  });
};

  const updateLiveAnalytics = async (nowPlaying, event, time) => {
    const isLive = "1";
    const updateResponse = await onVideoPlayFunction(
      appInfo,
      nowPlaying,
      event,
      time,
      isLive
    );
  };
  const ContinueWatchingHandler = async () => {
    localStorage.setItem('initialLoaded', 'true');
    
    let channelIdToUse;
    if (channelId) {
      channelIdToUse = channelId;
    } else if (c) {
      channelIdToUse = c;
    } else if (location?.state?.homelive === true && location?.state?.channelId) {
      channelIdToUse = location.state.channelId;
    } else if (channelData?.channel_id) {
      channelIdToUse = channelData.channel_id;
    }
    
        if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
          navigate("/checkout", { state: { channelId: channelIdToUse } });
        } else {

          if (!user) {
            navigate("/login", { state: { path: location?.pathname } });
          } else {
            navigate("/subscription", {
              state: { channelId: channelIdToUse },
            });
          }
        }
    };
  const readMoreOrLessHandler = (type) => {
    if (type === "more") {
      if (fastchannelData?.now_playing?.video_description) {
        setSliceCount(fastchannelData?.now_playing?.video_description?.length);
        setIsReadMore(false);
      }
    } else {
      setSliceCount(550);
      setIsReadMore(true);
    }
  };
  const handleCategorySelection = (item) => {
    setIsCategoryChange(true); 
    setSelectedCategory(item);
    setselectedCategoryName(item?.category_name);
    setCategoryButton(false);
  };

   if (pageLoading) {
    return <Loading />;
  }

  return (
    <div className={`liveChannelsContainer2 ${isRTL && "rtl"}`} role="region" aria-label="Live Channels">
      {scheduleModal?.isOpen && <ScheduleDetailsModal />}
{/* 
      {isContinueWithSubscriptionModal && 
      <ContinueWithSubscriptionModal
        setIsContinueWithSubscriptionModal={setIsContinueWithSubscriptionModal}
        channelData={channelData}
        appInfo={appInfo}
      />} */}
      {isNoScheduleAvailableModal && <NoScheduleAvailableModal />}
      {
        !loading &&
        <div className="topContainer">
          <div
            className="bgImage"
            // style={
            //   channelData?.image ? (

            //     imageUrlCheck(channelData?.image) === true
            //       ? {
            //         backgroundImage: `url(${channelData?.image})`,
            //       }
            //       : {
            //         backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL +
            //           channelData?.image
            //           })`,
            //       }
            //   ) : (
            //     {
            //       backgroundImage: `url(${projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE
            //         })`,
            //     }

            //   )
            // }
          >

          </div>
          <div className="wrapper">

            <div className="bannerContainer" aria-label="Channel Banner">
              <div className="bannerGradient" aria-hidden="true"></div>
              <div className="info" aria-label="Channel Info">
                <div className="liveLabel" role="status" aria-live="polite">
                  <LiveIcon aria-hidden="true" />
                  <span><Translate textKey={"live_caps"} /></span>
                </div>
                {fastchannelData?.channel_name && <h1 className="title">Channel: {fastchannelData?.channel_name}</h1>}
                <h2 className="videotitle">{fastchannelData?.now_playing?.video_title || fastchannelData?.now_playing?.title}</h2>
                <div className="descriptionContainer" aria-label="Channel Description">
                    <p className="description">
                      {fastchannelData?.now_playing?.video_description && (
                          <>
                            <span
                              className={`description-text${isReadMore ? " clamp-2-lines" : ""}`}
                              aria-label="Show description"
                              onClick={
                                fastchannelData?.now_playing?.video_description.split("\n").length > 2 && isReadMore
                                  ? () => readMoreOrLessHandler("more")
                                  : undefined
                              }
                            >
                              {parse(
                                fastchannelData?.now_playing?.video_description.replace(/\n/g, "<br>")
                              )}
                            </span>
                          
                            {isReadMore &&
                              fastchannelData?.now_playing?.video_description.split("\n").length > 2 && (
                                <span
                                  className="readMore"
                                  aria-label="Read more"
                                  role="button"
                                  onClick={() => readMoreOrLessHandler("more")}
                                >
                                  <Translate textKey={"read_more"} />
                                </span>
                              )}
                            {!isReadMore && (
                              <span
                                className="readLess"
                                aria-label="Read less"
                                role="button"
                                onClick={() => readMoreOrLessHandler("less")}
                              >
                                <Translate textKey={"read_less"} />
                              </span>
                            )}
                          </>
                        )}
                    </p>
                </div>

                <div className="additionalInfo" aria-label="Additional Info">
                  <ul>
                    {fastchannelData?.rating && <li>{fastchannelData?.rating}</li>}
                    {timeLeft && <li>{timeLeft} <Translate textKey={'left_small'}/></li>}
                    {fastchannelData?.categories && fastchannelData?.categories?.length > 0 && <li>{fastchannelData?.categories[0]?.category_name}</li>}
                  </ul>
                  {channelData?.rating && <span className="rating">{channelData?.rating}</span>}
                </div>
                 <div className="buttonsContainer" aria-label="Live Controls">
                    <div className="live-button"> 
                        {isLivePlaying && !isLivePaused ? (
                        <button onClick={handlePauseLive} aria-label="Pause live stream"><PauseButton aria-hidden="true" /> <Translate textKey={"live"} /></button>
                        ) : (
                        <button onClick={handleWatchNowLive} aria-label="Play live stream"><PlayButton aria-hidden="true" /> <Translate textKey={"live"} /></button>
                        )}
                    </div>
                                  
                 </div>

              </div>
            </div>
            <div className={`videoContainer ${hideEpg ? 'show-fullscreen-only' : 'hide-all-controls'}`} aria-label="Live Video Container">
             
              {livePlayer && (isLivePlaying && !isLivePaused) ? (
                livePlayer
              ) : (
                <div className="videoImageContainer" style={{ width: '100%' }}>

                <div className="banner-image" style={{ width: '100%'}} aria-label="Channel Logo">
                  {fastchannelData?.logo_thumb ? (
                    imageUrlCheck(fastchannelData?.logo_thumb) ? (
                      <img src={fastchannelData?.logo_thumb} alt="Logo" />
                    ) : (
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}${fastchannelData?.logo_thumb}`}
                        alt="Logo"
                      />
                    )
                  ) : null}
                </div>

              </div>
            )}
          </div>
          </div>
          {/* <div className="gradient"></div> */}
        </div>
      }
        {
          !hideEpg && categories && categories?.length > 0 &&(
            <div className="categoryAll" aria-label="Channel Categories">
                <div
                className="categoryContainer"
                aria-label="Select category"
                role="button"
                onClick={() => setCategoryButton(!categoryButton)}
                >
                <span className="selected">{selectedCategoryName}</span>
                <div className={categoryButton ? "list active" : "list"} aria-label="Category list">
                  {categories?.map((item, index) => (
                    <div className="item"
                         key={index}
                         aria-label={item?.category_name ? item.category_name.replace(/\s*\(/g, ' ').replace(/\)/g, '').replace(/\s+/g, ' ').trim() : ''}
                         role="option"
                         onClick={() => handleCategorySelection(item)}
                    >
                      <span>{item?.category_name ? item.category_name.replace(/\s*\(/g, ' ').replace(/\)/g, '').replace(/\s+/g, ' ').trim() : ''}</span>
                    </div>
                  ))}
                </div>
                <Arrow className={categoryButton ? "active" : "no-active"} aria-hidden="true" />
              </div>
            </div>
          )
        }
      {
        fastchannelData?.logo && ( isLiveVideoSub?.length === 0) || (!subscribedUser )&& (
        <div className="banner-text" role="alert" aria-live="assertive">
          <h2>{videoSubscription?.data?.subscribe_message}</h2>
          {
            videoSubscription?.data &&
            <button onClick={ContinueWatchingHandler}><Translate textKey={'proceed'}/></button>
          }
         
        </div>
      )
      }
      <div style={{ display: hideEpg ? 'none' : 'none' }}>
        <LiveEpgContainer selectedCategory={selectedCategory} />
      </div>

      {/* <div className="wrapper">
        <div className="categories">
          <div className="buttons">
            <button className="active">Featured</button>
            <button>Recently Added</button>
            <button>National News</button>
            <button>Sports on Tubi</button>
            <button>Business News</button>
            <button>Featured</button>
            <button>Recently Added</button>
            <button>National News</button>
            <button>Sports on Tubi</button>
            <button>Business News</button>

          </div>
        </div>
        <div className="scheduleTime">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => (
            <div className="time" key={index}>
              <span>{item}:00 AM</span>
            </div>
          ))}
        </div>

        <div className="scheduleContainer">
          <div className="rightGradient"></div>
            {
              [1,2,3,4,5,6].map((channel,channelIndex)=>(
                <div className={channelIndex===0?"channel showTimeline":"channel"} key={channelIndex}>
                  <div className="left">
                    <div className="currentPlayingCard">
                      <div className="imageContainer">
                        <img
                          src="http://images.adrise.tv/EAhmna34uo8gBwuvhlqek4TclEw=/50x0:1887x1080/978x576/smart/img.adrise.tv/ea3c6862-8e85-4461-8e59-4fe949343398.png"
                          alt="image"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="right">

                    {[
                      "100%",
                      "100px",
                      "56px",
                      "150px",
                      "100%",
                      "100px",
                      "100px",
                      "32px",
                      "100px",
                      "300px",
                      "500px",
                    ].map((item, index) => (
                      <div
                        className={
                          index === 0 ? "active scheduledItem" : "scheduledItem"
                        }
                        style={{ width: item }}
                        onClick={()=>setScheduleModal(true)}
                      >
                  <div className="progress">
                    <div className="currentTime">
                      <div className="icon">
                        <LiveIcon/>
                      </div>
                      <span>
                        12:44 PM

                        </span>
                    </div>
                  </div>

                        <h1>Show Name</h1>
                        <div className="metaData">
                          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam nulla modi vel laboriosam, cum asperiores nisi voluptatibus incidunt est error?</p>
                          <div className="infoIcon">
                            <InfoIcon/>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            }
        </div>
      </div> */}
    </div>
  );
};

export default LiveChannels2;
